export enum LoginStep {
    LOGIN = 'login',
    REGISTER = 'register'
}